<template>
  <div id="payment-request-button" class="px-4 flex-1"></div>
</template>

<script>
import gql from "graphql-tag"
import StripeMounter from "@/lib/StripeMounter"

const CART_ID_QUERY = gql`
  {
    checkoutCart @client {
      id
    }
  }
`

export default {
  name: "Cart.Stripe",
  apollo: {
    init: {
      manual: true,
      query: CART_ID_QUERY,
      result({ data }) {
        if (data) {
          this.cartId = data.checkoutCart.id
        }
      },
    },
  },
  data: () => ({
    paymentRequest: null,
  }),
  mounted() {
    this.$nextTick(() => {
      this.mountStripe()
    })
    this.$root.$on("cart-discount-updated", (cart) => {
      if (this.cartId == cart.id) {
        this.cartUpdated(cart)
      }
    })
  },
  methods: {
    async mountStripe() {
      const stripeMounter = new StripeMounter(this.cartId)
      const stripeData = await stripeMounter.initializePaymentRequest()
      const { button, payment_request } = stripeData
      // Check the availability of the Payment Request API first.
      const result = await payment_request.canMakePayment()
      if (result) {
        this.$emit("show")
        this.paymentRequest = payment_request
        button.mount("#payment-request-button")
      }
    },
    cartUpdated(cart) {
      if (this.paymentRequest) {
        this.paymentRequest.update({
          total: {
            label: "Total ($)",
            amount: cart.total.cents,
          },
        })
      }
    },
  },
}
</script>
